import { Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';

export default function Modal({ show = false, onClose, title, description, icon, iconBg = 'bg-emerald-100', iconColor = 'text-emerald-800', maxWidth = 'md', children }) {
    const maxWidthClass = { sm: 'max-w-sm', md: 'max-w-md', lg: 'max-w-lg', xl: 'max-w-xl', '2xl': 'max-w-2xl' }[maxWidth];

    return (
        <Transition show={show} as={Fragment}>
            <Dialog as="div" className="fixed inset-0 z-50 overflow-y-auto" onClose={onClose}>
                <div className="min-h-screen flex items-center justify-center p-4">
                    <Transition.Child as={Fragment} enter="ease-out duration-300" enterFrom="opacity-0" enterTo="opacity-100" leave="ease-in duration-200" leaveFrom="opacity-100" leaveTo="opacity-0">
                        <div className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm" />
                    </Transition.Child>

                    <Transition.Child as={Fragment} enter="ease-out duration-300" enterFrom="opacity-0 scale-95" enterTo="opacity-100 scale-100" leave="ease-in duration-200" leaveFrom="opacity-100 scale-100" leaveTo="opacity-0 scale-95">
                        <Dialog.Panel className={`relative bg-white rounded-2xl shadow-2xl w-full ${maxWidthClass} transform transition-all`}>
                            <div className="flex items-center justify-between p-6 border-b border-slate-100">
                                <div className="flex items-center gap-3">
                                    {icon && (
                                        <div className={`w-10 h-10 rounded-xl ${iconBg} flex items-center justify-center`}>
                                            <span className={iconColor}>{icon}</span>
                                        </div>
                                    )}
                                    <div>
                                        {title && <Dialog.Title className="text-lg font-semibold text-slate-800">{title}</Dialog.Title>}
                                        {description && <p className="text-sm text-slate-500">{description}</p>}
                                    </div>
                                </div>
                                <button onClick={onClose} className="p-2 hover:bg-slate-100 rounded-lg transition-colors">
                                    <XMarkIcon className="w-5 h-5 text-slate-400" />
                                </button>
                            </div>
                            {children}
                        </Dialog.Panel>
                    </Transition.Child>
                </div>
            </Dialog>
        </Transition>
    );
}

export function ModalBody({ children, className = '' }) {
    return <div className={`p-6 ${className}`}>{children}</div>;
}

export function ModalFooter({ children, className = '' }) {
    return <div className={`flex items-center justify-end gap-3 p-6 border-t border-slate-100 bg-slate-50 rounded-b-2xl ${className}`}>{children}</div>;
}
